import React, { useCallback } from "react";
import handlePostApproveOrder from "../../Utils/handlePOST/handlePostApproveOrder";
import handlePutOrders from "../../Utils/handlePUT/handlePutOrders";
import {
  getUsersWorkCenter,
  getUsersRoles,
  getUserId,
  checkRoles,
} from "../../Utils/helper";
import renderBarStatus from "./renderConst";
import { useNavigate } from "react-router-dom";
import useFetch from "../../Hooks/useFetch";
import "./orderProgressBar.css";

const stepKey = [
  { value: 0, text: "New Order", id: 0 },
  { value: 1, text: "Supervisor Approved", id: 1 },
  { value: 2, text: "PCard Approved", id: 2 },
  { value: 3, text: "Order Processing", id: 15 },
  { value: 4, text: "Ordered", id: 6 },
  { value: 5, text: "Shipped", id: 7 },
  { value: 6, text: "Out for Delivery", id: 8 },
  { value: 7, text: "Delivered", id: 9 },
];

const arraySize = stepKey.length;
export default function ApprovalStatusBar({
  data,
  status,
  mutate,
  setNotifications,
}) {
  const navigate = useNavigate,
    fetch = useFetch(navigate);
  const usersWorkCenter = getUsersWorkCenter()?.name || "",
    userRole = getUsersRoles(),
    isAdmin = userRole.includes("Administrator"),
    isUserOrderer =
      userRole.includes("Coordinator") ||
      getUserId() === "d4ec0560-d7b0-4385-81a3-ef5ac53df4da",
    isOrderButtonVisible =
      isUserOrderer &&
      ((data.status >= 2 && data.status <= 6) || data.status === 15) &&
      (usersWorkCenter === "Operations" || usersWorkCenter === "Processing");

  const handleApproval = useCallback(async () => {
    const { response, isDataGood } = await handlePostApproveOrder(
      data.id,
      fetch,
    );
    console.log("response, isGoodData", response, isDataGood);
    setNotifications(response);
    if (isDataGood) {
      mutate();
    }
  }, [data.id, mutate, fetch, setNotifications]);

  const handleEditStatus = useCallback(
    async (statusId) => {
      const { response, isDataGood } = await handlePutOrders(
        data,
        statusId,
        fetch,
      );
      console.log("response, isGoodData", response, isDataGood);
      setNotifications(response);
      if (isDataGood) {
        mutate();
      }
    },
    [data, fetch, mutate, setNotifications],
  );

  //updates the status based on package.place
  //if (status && status !== data.status) {
  //    handleEditStatus(status);
  //}

  function Steps({ currentStep = 0 }) {
    const createArray = (length) => [...Array(length)];

    if (currentStep > arraySize) {
      return (
        <Step
          key={0}
          done={true}
          selected={true}
          step={stepKey.find((x) => x.value === currentStep)}
        />
      );
    }
    return createArray(arraySize).map((n, i) => (
      <Step
        key={i}
        currentStep={currentStep}
        done={currentStep > i}
        selected={currentStep === i}
        step={stepKey.find((x) => x.value === i)}
      />
    ));
  }

  function Step({ step, done, selected, currentStep }) {
    const validation = (notButton) => {
      if (step.value <= currentStep) return false;

      if (
        (currentStep === 0 && checkRoles(2) && step.value === 1) ||
        (currentStep === 1 && isAdmin && step.value === 2) // made the isAdmin account to approve the pcardApproved
      ) {
        if (notButton) return true;
        return handleApproval();
      } else if (
        (currentStep === 2 && isOrderButtonVisible && step.id === 15) ||
        (currentStep === 3 && isOrderButtonVisible && step.id === 6)
      ) {
        if (notButton) return true;
        return handleEditStatus(step.id);
      } else {
        return false;
      }
    };

    return (
      <div
        className={`step ${done ? "done" : ""} ${selected ? "current" : ""}`}
        onClick={() => validation(false)}
        style={{ padding: step.value > arraySize ? "10px" : null }}
      >
        <span className={`${validation(true) ? "progressButton" : null}`}>
          {step.text}
        </span>
      </div>
    );
  }

  const currentStep = stepKey.find((x) => x.id === data.status);
  const newStatus = data.status > 9 && data.status !== 15;

  // this displayed only one status -> On hold, Denied, Cancelled, Out of Stock, Order edited
  if (data.status === 3 || newStatus) {
    return renderBarStatus(data.status);
  }

  return (
    <>
      <div className="arrow-steps center clearfix">
        <Steps currentStep={currentStep?.value} />
      </div>
    </>
  );
}
